import React, { useContext, useEffect, useRef, useState } from 'react';
import TablePlayerTargetTurnover from "components/TablePlayerTargetTurnover";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../config/axios";
import { useDebouncedCallback } from 'use-debounce';
import Swal from "sweetalert2";
import { RootContext } from '../../App';
import refactorStructureData from '../../helpers/refactorDataMenu';
export default function PlayerTargetTurnover() {

  const history = useHistory();
  const [playerTargetTurnover, setPlayerTargetTurnover] = useState([])
  const [pending, setPending] = useState(true);
  const [username, setUsername] = useState(null)
  const [clearUsername, setClearUsername] = useState(null)
  const [length, setLength] = useState(10)
  const isFirstRender = useRef(true)
  const { state, setState } = useContext(RootContext)
  const debounced = useDebouncedCallback(
    (action) => {
      action()
    },
    200
  );

  useEffect(() => {

    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username])

  useEffect(() => {

    if (isFirstRender.current) {

      isFirstRender.current = false
      return
    }

    clearTargetTurnover()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearUsername])

  const getData = () => {

    const token = localStorage.getItem("access_token");
    const group = JSON.parse(localStorage.getItem("group"))

    if (!token) {
      history.push("/login");
    } else {
      try {
        axiosInstance("get-target-turnover", {
          method: "POST",
          data: {
            token: token,
            group: group.wbid,
            user: username
          },
        })
          .then((res) => {
            setState({
              ...state,
              group: res.data.data.additional_data.group,
              menu: refactorStructureData(res.data.data.additional_data.menu),
            });
            setPlayerTargetTurnover(res.data.data.list)
            setPending(false);
          })
          .catch((err) => {
            localStorage.removeItem("access_token");
            history.push("/login");
          });
      } catch (error) {
        console.log("ERROR: ", error);
      }
    }
  };

  const clearTargetTurnover = () => {

    const token = localStorage.getItem("access_token");
    const group = JSON.parse(localStorage.getItem("group"));

    setPending(true);

    if (!token) {
      history.push("/login");
    } else {
      try {
        axiosInstance("clear-target-turnover", {
          method: "POST",
          data: {
            token: token,
            group: group.wbid,
            username: clearUsername
          },
        })
          .then((res) => {

            if(res.data.code == 0) {

              setPlayerTargetTurnover(res.data.data);
              setPending(false);

              Swal.fire("Success", `Target turnover for ${clearUsername} has been cleared.`, "success");
            }else{

              Swal.fire("Error", `Failed to clear target turnover for ${clearUsername}.`, "error");
            }
          })
          .catch((err) => {
            localStorage.removeItem("access_token");
            history.push("/login");
          });
      } catch (error) {
        console.log("ERROR: ", error);
      }
    }
  };

  return (
    <>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto">
      </div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <TablePlayerTargetTurnover title="Target Turnover" dataTable={playerTargetTurnover} pending={pending}
              usernameEvent={(event) => {
                debounced(() => setUsername(event.target.value))
              }}
              clearTargetTurnoverEvent={(event) => {
                debounced(() => setClearUsername(event.target.value))
              }}
              onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                setLength(currentRowsPerPage)
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
